import styled from 'styled-components';
import { lightGrey1Color, lightGrey3Color } from 'js/config/style';

export default styled.div`
  font-size: 0.8rem;
  color: ${lightGrey3Color};
  height: 2.5rem;
  line-height: 2.5rem;
  position: relative;
  padding-left: 1rem;
  border-bottom: 1px solid ${lightGrey1Color};
`;
